export default __webpack_public_path__ + "static/media/menu_locations_black.a0f30a08.svg";